'use client';

import { __assign, __rest } from '../_virtual/_tslib.js';
import React__default, { useState, useRef } from 'react';
import { Container, Hide, Logo, Desc, SalaryLocationWrapper, SettingContainer, SettingWrapper } from './JobCardMini.css.js';
import PreviewJob from '../PreviewJob/index.js';
import SettingJob from '../SettingJob/index.js';
import { DEFAULT_JOB_IMAGE } from '../JobYouWillLove/constant.js';
import { ELanguage } from '../Utils/constants.js';
import { EVariant } from './type.js';
import BadgeTag from '../BadgeTag/index.js';
import translations from './translations.js';
import { SkillTagWrapper } from './SkillTag/SkillTag.css.js';
import SkillTag from './SkillTag/index.js';
import ApplyJobs from '../ApplyJobs/index.js';
import { JobInvitationIcon } from '../JobCard/JobCard.css.js';
import MailAddIcon from '../Images/MailAddIcon/index.js';
import { EJobInvitationStatus } from '../ApplyJobs/types.js';

var PreviewJobWrapper = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var langCode = props.langCode, setShowPopup = props.setShowPopup, api = props.api, isApplied = props.isApplied, isBlackList = props.isBlackList, redirectTo = props.redirectTo, previewJob = props.previewJob, isMobile = props.isMobile, isNldPage = props.isNldPage, jobId = props.jobId, jobLogo = props.jobLogo, jobTitle = props.jobTitle, prettySalary = props.prettySalary, jobLevelText = props.jobLevelText, address = props.address, jobDescription = props.jobDescription, jobRequirement = props.jobRequirement, jobUrl = props.jobUrl, isSaved = props.isSaved, jobInvitation = props.jobInvitation;
    return (previewJob === null || previewJob === void 0 ? void 0 : previewJob.enable) && !isMobile ? (React__default.createElement(PreviewJob, { isNLDPage: isNldPage, content: {
            jobId: jobId,
            logo: jobLogo,
            title: jobTitle,
            salary: prettySalary || '',
            jobLevel: jobLevelText,
            address: address,
            jobDescription: jobDescription,
            jobRequirements: jobRequirement,
            link: jobUrl,
            isSaved: !!isSaved,
            isApplied: !!isApplied,
            isBlackList: !!isBlackList,
            redirectTo: redirectTo || '',
            jobInvitation: jobInvitation
        }, api: {
            accessToken: api.accessToken,
            baseUrl: api.baseUrl
        }, onApplyClick: function () { return setShowPopup(true); }, langCode: langCode, isLogin: !!api.accessToken }, children)) : (React__default.createElement(React__default.Fragment, null, children));
};
var JobCardMini = function (props) {
    var _a, _b, _c, _d, _e;
    var item = props.item, langCode = props.langCode, api = props.api, previewJob = props.previewJob, displayOptions = props.displayOptions, settingJob = props.settingJob, isMobile = props.isMobile, _f = props.classSelector, classSelector = _f === void 0 ? 'top_recommend' : _f, userInfo = props.userInfo, _g = props.isNldPage, isNldPage = _g === void 0 ? false : _g;
    var isAnonymous = item.isAnonymous, company = item.company, companyLogo = item.companyLogo, companyUrl = item.companyUrl, jobDescription = item.jobDescription, jobId = item.jobId, jobLevelText = item.jobLevelText, jobRequirement = item.jobRequirement, jobTitle = item.jobTitle, jobUrl = item.jobUrl, locationText = item.locationText, prettySalary = item.prettySalary, address = item.address, isApplied = item.isApplied, isBlackList = item.isBlackList, isSaved = item.isSaved, redirectTo = item.redirectTo, skills = item.skills;
    var _h = useState(false), isHideJob = _h[0], setHideJob = _h[1];
    var _j = useState(false), showPopup = _j[0], setShowPopup = _j[1];
    var _k = useState(false), showSettingJob = _k[0], setShowSettingJob = _k[1];
    var settingJobRef = useRef(null);
    var jobLogo = companyLogo && !isAnonymous ? companyLogo : DEFAULT_JOB_IMAGE;
    var showCompanyUrl = isAnonymous ? '' : companyUrl;
    var formatLocationText = String(locationText)
        .split(', ')
        .filter(function (item, index, self) { return self.indexOf(item) === index; })
        .join(', ');
    var previewJobProps = {
        langCode: langCode,
        setShowPopup: setShowPopup,
        api: api,
        isApplied: isApplied,
        isBlackList: isBlackList,
        redirectTo: redirectTo,
        previewJob: previewJob,
        isMobile: isMobile,
        isNldPage: isNldPage,
        jobId: jobId,
        jobLogo: jobLogo,
        jobTitle: jobTitle,
        prettySalary: prettySalary,
        jobLevelText: jobLevelText,
        address: address,
        jobDescription: jobDescription,
        jobRequirement: jobRequirement,
        jobUrl: jobUrl,
        isSaved: isSaved,
        jobInvitation: props.item.jobInvitation
    };
    var t = function (key) {
        if (langCode === ELanguage.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var isHaveJobInvitation = item.jobInvitation &&
        ((_a = item.jobInvitation) === null || _a === void 0 ? void 0 : _a.jobInvitationId) > 0 &&
        ((_b = item.jobInvitation) === null || _b === void 0 ? void 0 : _b.status) === EJobInvitationStatus.WAITING;
    return (React__default.createElement(Container, { className: classSelector }, isHideJob ? (React__default.createElement(Hide.Container, null,
        React__default.createElement(Hide.Info, null,
            React__default.createElement(Hide.Title, null, t('Job hidden')),
            React__default.createElement(Hide.Text, null, t('You will not see this job on the search page.'))),
        React__default.createElement("div", null,
            React__default.createElement(SettingJob, { api: api, jobId: jobId, langCode: langCode, onHideJobClick: function () { return setHideJob(false); }, isHide: isHideJob })))) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Logo, null,
            React__default.createElement("img", { src: jobLogo, alt: 'logo', loading: 'lazy' })),
        React__default.createElement(Desc.Container, null,
            React__default.createElement(PreviewJobWrapper, __assign({}, previewJobProps),
                React__default.createElement(Desc.Title, null,
                    React__default.createElement("h3", { style: { fontSize: '18px' } },
                        isHaveJobInvitation ? (React__default.createElement(JobInvitationIcon, null,
                            React__default.createElement(MailAddIcon, { width: 20, height: 20 }))) : null,
                        React__default.createElement("a", { href: jobUrl, target: isMobile ? '_self' : '_blank' }, jobTitle)))),
            React__default.createElement(Desc.SubTitle, null, showCompanyUrl ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("a", { target: isMobile ? '_self' : '_blank', href: showCompanyUrl }, company))) : (company)),
            (settingJob === null || settingJob === void 0 ? void 0 : settingJob.variant) === EVariant.SECONDARY ? (React__default.createElement(SalaryLocationWrapper, null,
                React__default.createElement(Desc.Salary, null, prettySalary),
                React__default.createElement("span", { className: 'line-break' }),
                React__default.createElement(Desc.SubTitle, null, formatLocationText))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Desc.Salary, null, prettySalary),
                React__default.createElement(Desc.SubTitle, null, formatLocationText))),
            (settingJob === null || settingJob === void 0 ? void 0 : settingJob.isShowSkills) && skills && skills.length > 0 && !isMobile ? (React__default.createElement(SkillTagWrapper, null,
                React__default.createElement(SkillTag, { data: skills }))) : null),
        React__default.createElement(SettingContainer, null,
            (displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.isHot) ? (React__default.createElement(BadgeTag, { type: 'Hot', langCode: langCode })) : (React__default.createElement("div", { style: { height: '100%' } })),
            !isNldPage && (previewJob === null || previewJob === void 0 ? void 0 : previewJob.enable) ? (React__default.createElement(SettingWrapper, { isShow: isMobile ? true : showSettingJob },
                React__default.createElement(SettingJob, { ref: settingJobRef, type: 'horizontal', showPopupType: settingJob === null || settingJob === void 0 ? void 0 : settingJob.showType, api: api, jobId: jobId, langCode: langCode, onHideJobClick: function () { return setHideJob(true); }, onShowChange: function (e) { return setShowSettingJob(e); }, isHide: isHideJob }))) : null,
            !isNldPage && !isMobile ? (React__default.createElement(ApplyJobs, { accessToken: (_c = api === null || api === void 0 ? void 0 : api.accessToken) !== null && _c !== void 0 ? _c : '', isOpen: showPopup, langCode: langCode, user: userInfo, jobInfo: __assign({}, props.item), baseMsUrl: (_d = api.baseUrl) !== null && _d !== void 0 ? _d : '', baseUrl: (_e = previewJob === null || previewJob === void 0 ? void 0 : previewJob.baseUrl) !== null && _e !== void 0 ? _e : '', initData: props.initData, onClose: function () { return setShowPopup(false); } })) : null)))));
};

export { JobCardMini as default };
//# sourceMappingURL=index.js.map
